import { createContext, useContext } from 'react';
export const FormContext = /*#__PURE__*/createContext({
  labelSpan: null,
  recalcTrigger: 0
});
export function useFormContext() {
  return useContext(FormContext);
}
export const GroupContext = /*#__PURE__*/createContext({});
export function useFormGroupContext() {
  return useContext(GroupContext);
}